import React, { useState, useEffect } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import classnames from "classnames";
import { ReactSVG } from "react-svg";
import DellLogo from "../images/logos/dell-logo.svg";
import navData from "../data/navigation.json";
import ConnectIcon from "../images/nav-icons/connected-laptop.svg";
import EdgeIcon from "../images/nav-icons/edge.svg";
import PrivateIcon from "../images/nav-icons/private-mobility.svg";
import CyberIcon from "../images/nav-icons/cyber-recovery.svg";
import InteIcon from "../images/nav-icons/integrated-solution.svg";
import HomeIconHover from "../images/home-btn-hover@2x.png";
import HomeIcon from "../images/home-btn@2x.png";

const Navigation = () => {
    let location = useLocation();
    const [hoverNav, setHoverNav] = useState();
    const [activeLink, setActiveLink] = useState();
    const setActive = () => {
    if (location.pathname === "/") {
      setActiveLink();
    }
    if (
      location.pathname === "/connected-laptop" ||
      location.pathname === "/connected-laptop/customer-office" ||
      location.pathname === "/connected-laptop/on-the-move" ||
      location.pathname === "/connected-laptop/work-from-home"
    ) {
      setActiveLink(0);
    }
    if (
      location.pathname === "/edge-compute" ||
      location.pathname === "/edge-compute/logistics" ||
      location.pathname === "/edge-compute/manufacturing"
    ) {
      setActiveLink(1);
    }
    if (
      location.pathname === "/private-wireless" ||
      location.pathname === "/private-wireless/campus" ||
      location.pathname === "/private-wireless/airports"
    ) {
      setActiveLink(2);
    }
    if (
      location.pathname === "/cyber-recovery" ||
      location.pathname === "/cyber-recovery/retail-operation" ||
      location.pathname === "/cyber-recovery/healthcare"
    ) {
      setActiveLink(3);
    }
    if (location.pathname === "/integrated-solution") {
      setActiveLink(4);
    }
  };

  useEffect(() => {
    setActive();
  }, []);

  return (
    <div className="flex justify-between fixed top-0 left-0 w-full z-50 zoom-8 navigation">
      <div className="flex items-center pl-10 logo-bg-grad flex-1">
        <Link
          to={"/home"}
          onClick={() => {
            setActiveLink();
          }}
        >
          <img
            alt="Dell Technologies Logo"
            src={DellLogo}
            className="relative bottom-3  xl:w-[170px]"
          />
        </Link>
      </div>
      <div className="flex">
        {navData.map((nav, i) => {
          console.log(activeLink + " " + i);
          let icon;
          if (nav.label === "Connected Laptop") {
            icon = (
              <img
                alt="Connected laptop icon"
                src={ConnectIcon}
                className={classnames(
                  "absolute xl:mt-[5px] scale-[70%] 2xl:scale-100 2xl:mt-10 transition-opacity duration-500 delay-100",
                  hoverNav === i
                    ? "opacity-100"
                    : activeLink === i
                    ? "opacity-100"
                    : "opacity-0"
                )}
              />
            );
          } else if (nav.label === "Edge Compute") {
            icon = (
              <img
                alt="Edge compute icon"
                role={"Icon"}
                src={EdgeIcon}
                className={classnames(
                  "absolute xl:mt-[5px] scale-[70%] 2xl:scale-100 2xl:mt-10 transition-opacity duration-500 delay-100",
                  hoverNav === i
                    ? "opacity-100"
                    : activeLink === i
                    ? "opacity-100"
                    : "opacity-0"
                )}
              />
            );
          } else if (nav.label === "Private Wireless") {
            icon = (
              <img
                alt=""
                src={PrivateIcon}
                className={classnames(
                  "absolute xl:mt-[5px] scale-[70%] 2xl:scale-100 2xl:mt-10 transition-opacity duration-500 delay-100",
                  hoverNav === i
                    ? "opacity-100"
                    : activeLink === i
                    ? "opacity-100"
                    : "opacity-0"
                )}
              />
            );
          } else if (nav.label === "Cyber Recovery") {
            icon = (
              <img
                alt=""
                src={CyberIcon}
                className={classnames(
                  "absolute xl:mt-[5px] scale-[70%] 2xl:scale-100 2xl:mt-10 transition-opacity duration-500 delay-100",
                  hoverNav === i
                    ? "opacity-100"
                    : activeLink === i
                    ? "opacity-100"
                    : "opacity-0"
                )}
              />
            );
          } else if (nav.label === "Integrated Solution") {
            icon = (
              <img
                alt=""
                src={InteIcon}
                className={classnames(
                  "absolute xl:mt-[5px] scale-[70%] 2xl:scale-100 2xl:mt-10 transition-opacity duration-500 delay-100",
                  hoverNav === i
                    ? "opacity-100"
                    : activeLink === i
                    ? "opacity-100"
                    : "opacity-0"
                )}
              />
            );
          } else {
            return null;
          }
          return (
            <NavLink
              className={classnames(
                `xl:w-[177px] xl:h-[120px] 2xl:w-[254px] relative 2xl:h-[172px] flex flex-col justify-center align-middle items-center font-proxima-nova
                ${i !== 0 ? "ml-[5px]" : ""}
                ${location.pathname === i ? "active-link" : ""}
              `
                            )}
                            to={nav.url}
                            key={i}
                            onMouseEnter={() => {
                                setHoverNav(i);
                            }}
                            onMouseLeave={() => {
                                setHoverNav(null);
                            }}
                            onClick={() => {
                                setActiveLink(i);
                            }}
                        >
                            <div
                                className={classnames(
                                    "nav-bg-grad absolute w-full h-full duration-500 transition-all",

                                    hoverNav === i
                                        ? "opacity-0 top-[-100px]"
                                        : "opacity-100 top-0",

                                    activeLink === i ? "active-hide-bg" : ""
                                )}
                            />
                            <div
                                className={classnames(
                                    "nav-bg-grad-hover absolute w-full h-full duration-500 transition-all",

                                    hoverNav === i
                                        ? "opacity-100 top-0"
                                        : "opacity-0 top-[-100px]",

                                    activeLink === i ? "active-bg" : ""
                                )}
                            />
                            <p
                                className={classnames(`font-semibold xl:text-[80%] 2xl:text-[20px] text-2xl leading-7 relative bottom-3 duration-500 transition-all text-white
                ${
                                    hoverNav === i
                                        ? "bottom-7"
                                        : "bottom-3" + nav.url === i
                                        ? "active-bottom-7"
                                        : ""
                                }
                `)}
                            >
                                {nav.label}
                            </p>
                            {icon}
                        </NavLink>
                    );
                })}
            </div>
        <a  className={`fixed left-10 bottom-0 zoom-8 hidden`} href="#main">
            Skip to content
        </a>
            <div
                className={`fixed left-10 bottom-0 zoom-8 ${
                    location.pathname === "/home" ? "hidden" : "visible"
                }`}
            >
                <Link to={"/home"} onClick={() => {
                    setActiveLink();
                }} className={classnames("group/home-btn new-luke")}>
                    <img
                        alt="back to home page button"
                        src={HomeIconHover}
                        className="group-hover/home-btn:block opacity-80 hidden bottom-0 w-[55px] 2xl:w-[87px]"
                    />
                    <img
                        alt="Back to home page button"
                        src={HomeIcon}
                        className="group-hover/home-btn:hidden opacity-80 block bottom-0 w-[55px] 2xl:w-[87px]"
                    />
                </Link>
            </div>
        <div className="fixed opacity-0"><p><a className="skip-to-main-content-link">Skip to
            main content</a></p></div>
        </div>

    );
};

export default Navigation;
